import moment from 'moment';
import PropTypes from 'prop-types';
import compose from "ramda/es/compose";
import map from "ramda/es/map";
import o from "ramda/es/o";
import toPairs from "ramda/es/toPairs";
import unnest from "ramda/es/unnest";
import xprod from "ramda/es/xprod";
import cx from "ramda-extension/es/cx";
import noop from "ramda-extension/es/noop";
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside-decorator';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
import CalendarHeading from '../CalendarHeading';
import DatePickerCalendar from '../react-datepicker/calendar';
const COMPONENT_NAME = 'Calendar';
export const dotClasses = {
    RED: 'react-datepicker__notification-dot--red',
    GREEN: 'react-datepicker__notification-dot--green',
    BLUE: 'react-datepicker__notification-dot--blue',
    BLACK: 'react-datepicker__notification-dot--black'
};
const classToDatesToHighlightDates = compose((pairs)=>new Map(pairs), map(([date, cls])=>[
        date instanceof moment ? date.format('MM.DD.YYYY') : date,
        cls
    ]), unnest, map(([cls, dates])=>xprod(dates, [
        cls
    ])), toPairs);
class Calendar extends Component {
    static displayName = 'Calendar';
    handleSelect = (date)=>{
        if (this.props.onSelect) {
            this.props.onSelect(date.clone().format(this.props.dateFormat));
        }
    };
    render() {
        const { hideCalendarHeader, style, value, dateFormat, dateFormatCalendar, locale, showYearDropdown, showYearDropdownDateFormatCalendar, classToDates, ...other } = this.props;
        const parsed = value ? moment(value, dateFormat, locale) : null;
        const selected = parsed && !parsed.isValid() ? null : parsed;
        return /*#__PURE__*/ React.createElement("div", {
            className: cx('DatePicker-calendar', {
                'DatePicker-calendar--withControls': !hideCalendarHeader
            }, {
                'DatePicker-calendar--typeStatic': !hideCalendarHeader
            }, {
                'DatePicker-calendar--withHeader': !hideCalendarHeader
            }),
            style: style
        }, !hideCalendarHeader && selected ? /*#__PURE__*/ React.createElement(CalendarHeading, {
            date: selected
        }) : null, /*#__PURE__*/ React.createElement(DatePickerCalendar, {
            ...other,
            onClickOutside: noop,
            selected: selected,
            locale: locale,
            dateFormat: showYearDropdown ? showYearDropdownDateFormatCalendar : dateFormatCalendar,
            onSelect: this.handleSelect,
            showYearDropdown: showYearDropdown,
            dropdownMode: "scroll",
            highlightDates: classToDates && classToDatesToHighlightDates(classToDates)
        }));
    }
}
Calendar.propTypes = {
    /**
	 * Add class to specific dates. {'some-class': ['date1', 'date2']}
	 * Date must be in format MM.DD.YYYY or Moment object
	 */ classToDates: PropTypes.object,
    /**
	 * Date label format expression for left side controll panel.
	 */ dateFormat: PropTypes.string,
    /**
	 * Month and year label format expression for top controll panel.
	 */ dateFormatCalendar: PropTypes.string,
    /**
	 * Label for the day after tomorrow.
	 */ dayAfterTomorrowLabel: PropTypes.string,
    /**
	 * End of highlited date range.
	 */ endDate: PropTypes.object,
    /**
	 * Array of dates that should be disabled for selection.
	 */ excludeDates: PropTypes.array,
    /**
	 * Function that enables you to enable certain dates according to specified criteria.
	 *
	 * @param {moment} date moment object which is tested to meet the criteria
	 * @return {bool} true/false'
	 */ filterDate: PropTypes.func,
    /**
	 * If true, calendar header is hidden.
	 */ hideCalendarHeader: PropTypes.bool,
    /**
	 * Array of dates which selection is enabled.
	 */ includeDates: PropTypes.array,
    /**
	 * Calendar locale.
	 */ locale: PropTypes.string,
    /**
	 * Max selectable date.
	 */ maxDate: PropTypes.object,
    /**
	 * Min selectable date.
	 */ minDate: PropTypes.object,
    /**
	 * Label for tomorrow.
	 */ nextDayLabel: PropTypes.string,
    /**
	 * On select function
	 *
	 * @param {date} selected date
	 * @return {undefined} Nothing
	 */ onSelect: PropTypes.func,
    /**
	 * Label for today.
	 */ sameDayLabel: PropTypes.string,
    /**
	 * Show dropdown for year
	 */ showYearDropdown: PropTypes.bool,
    /**
	 * Month and year label format expression for top controll panel durring dropdown is visible.
	 */ showYearDropdownDateFormatCalendar: PropTypes.string,
    /**
	 * Start of highlited date range.
	 */ startDate: PropTypes.object,
    /**
	 * Style for datepicker
	 */ style: PropTypes.object,
    /**
	 * Value of the calendar
	 */ value: PropTypes.any
};
export { Calendar };
export default o(onClickOutside, withDefaultComponentProps(COMPONENT_NAME, {
    locale: 'cs',
    dateFormatCalendar: 'MMMM YYYY',
    showYearDropdownDateFormatCalendar: 'MMMM',
    dateFormat: 'L',
    sameDayLabel: 'Dnes',
    nextDayLabel: 'Zítra',
    dayAfterTomorrowLabel: 'Pozítří',
    value: moment().locale('cs').format('L')
}))(Calendar);
